export default __webpack_public_path__ + "static/chirag-d5f1414fd6da6fca2ca64f514657cc40.png";